<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="13"
    viewBox="0 0 8 13"
    fill="none"
  >
    <path
      d="M2.41145 6.49702L7.70631 1.58244C7.79938 1.49647 7.87325 1.39425 7.92365 1.28167C7.97405 1.16909 8 1.04836 8 0.926435C8 0.804504 7.97405 0.683778 7.92365 0.571196C7.87325 0.458613 7.79938 0.356398 7.70631 0.270425C7.51775 0.0971737 7.26323 -3.22051e-08 6.99802 -4.37982e-08C6.7328 -5.53912e-08 6.47828 0.0971736 6.28972 0.270425L0.291025 5.8366C0.10978 6.00562 0.00562888 6.23302 0.000222015 6.47152C-0.00518485 6.71003 0.0885694 6.9413 0.261994 7.11725L6.28558 12.7269C6.47288 12.9014 6.72713 12.9996 6.9924 13C7.25767 13.0004 7.51223 12.9028 7.70009 12.7288C7.88794 12.5549 7.99369 12.3187 7.99408 12.0723C7.99446 11.8258 7.88946 11.5894 7.70216 11.4149L2.41145 6.49702Z"
      fill="#213e7a"
    />
  </svg>
</template>

<script>
export default {
  name: "ArrowBack",
};
</script>

<style></style>
